// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { AssetIntegration_EntityFragment } from '../../../../assetProviderIntegrations/shared/graphql/assetProviderIntegration.fragments.generated';
import { gql } from '@apollo/client';
import { AssetIntegration_EntityFragmentDoc } from '../../../../assetProviderIntegrations/shared/graphql/assetProviderIntegration.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResyncEntityValuationMutationVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type ResyncEntityValuationMutation = { __typename?: 'Mutation', syncIntegratedEntity: string };

export type EntityValuationActionsLiabilities_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, liabilitiesOwed: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: { __typename?: 'Liability', id: string, displayName: string } | null } | null> | null }, liabilitiesLent: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: { __typename?: 'Liability', id: string, displayName: string } | null } | null> | null } };

export type EntityValuationActions_EntityFragment = (
  { __typename?: 'Entity', pauseIntegrationSync: boolean }
  & EntityValuationActionsLiabilities_EntityFragment
  & AssetIntegration_EntityFragment
);

export const Operations = {
  Mutation: {
    ResyncEntityValuation: 'ResyncEntityValuation' as const
  },
  Fragment: {
    EntityValuationActionsLiabilities_Entity: 'EntityValuationActionsLiabilities_Entity' as const,
    EntityValuationActions_Entity: 'EntityValuationActions_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityValuationActionsLiabilities_EntityFragmentDoc = gql`
    fragment EntityValuationActionsLiabilities_Entity on Entity {
  id
  kind
  liabilitiesOwed {
    edges {
      node {
        id
        displayName
      }
    }
  }
  liabilitiesLent {
    edges {
      node {
        id
        displayName
      }
    }
  }
}
    `;
export const EntityValuationActions_EntityFragmentDoc = gql`
    fragment EntityValuationActions_Entity on Entity {
  pauseIntegrationSync
  ...EntityValuationActionsLiabilities_Entity
  ...AssetIntegration_Entity
}
    ${EntityValuationActionsLiabilities_EntityFragmentDoc}
${AssetIntegration_EntityFragmentDoc}`;
export const ResyncEntityValuationDocument = gql`
    mutation ResyncEntityValuation($entityId: ID!) {
  syncIntegratedEntity(id: $entityId)
}
    `;
export type ResyncEntityValuationMutationFn = Apollo.MutationFunction<ResyncEntityValuationMutation, ResyncEntityValuationMutationVariables>;

/**
 * __useResyncEntityValuationMutation__
 *
 * To run a mutation, you first call `useResyncEntityValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncEntityValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncEntityValuationMutation, { data, loading, error }] = useResyncEntityValuationMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useResyncEntityValuationMutation(baseOptions?: Apollo.MutationHookOptions<ResyncEntityValuationMutation, ResyncEntityValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncEntityValuationMutation, ResyncEntityValuationMutationVariables>(ResyncEntityValuationDocument, options);
      }
export type ResyncEntityValuationMutationHookResult = ReturnType<typeof useResyncEntityValuationMutation>;
export type ResyncEntityValuationMutationResult = Apollo.MutationResult<ResyncEntityValuationMutation>;
export type ResyncEntityValuationMutationOptions = Apollo.BaseMutationOptions<ResyncEntityValuationMutation, ResyncEntityValuationMutationVariables>;